export default __webpack_public_path__ + "abf5d9e42ece3d00842bf44e58b6fea1.jpg";